import {useState} from "react"
import {createModel} from "hox"

function ShowAttachment() {
    const [status, setStatus] = useState(false)
    const [from, setFrom] = useState("Base")

    const init = () => {
        setStatus(false)
        setFrom("Base")
    }

    const toTrue = (source: string) => {
        setStatus(true)
        setFrom(source)
    }
    const toFalse = () => {
        setStatus(false)
    }
    return {
        value: status,
        from: from,
        init,
        toTrue,
        toFalse,
    }
}

export default createModel(ShowAttachment)
